<template>
  <div class="advertList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-field
            readonly
            :label="$t.marketRisk.advertType"
            label-class="number-label"
            :value="typeValueStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showAdvertListType')"
            v-if="searchType == 1"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :label="$t.marketRisk.showType"
            label-class="number-label"
            :value="isShowStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showAdvertListIsShow')"
            v-if="searchType == 2"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
          <van-field
            readonly
            :label="$t.marketRisk.moduleType"
            label-class="number-label"
            :value="moduleStr"
            :placeholder="$t.meta.select"
            @click-input="onShowEmit('showAdvertListModule')"
            v-if="searchType == 3"
          >
            <template #button>
              <van-button size="small" type="info" @click="onSearch">{{
                $t.meta.search
              }}</van-button>
            </template>
          </van-field>
        </van-col>
        <van-col class="colItem2">
          <div @click="handleSheetShow">
            <span>{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.marketRisk.advertTitle }}：{{ item.AdvertTitle }}
        </div>
        <div class="list-item">
          {{ $t.marketRisk.advertTypeStr }}：{{ item.AdvertTypeStr }}
        </div>
        <div class="list-item">{{ $t.marketRisk.moduleStr }}：{{ item.ModuleStr }}</div>
        <div class="list-item">{{ $t.marketRisk.lineUrl }}：{{ item.LinkUrl }}</div>
        <div class="list-item">
          {{ $t.marketRisk.isShow }}：
          <span v-if="item.IsShow == 1">{{ $t.meta.yes }}</span>
          <span v-if="item.IsShow == 0">{{ $t.meta.no }}</span>
        </div>
        <div class="buttons">
          <van-button
            :class="item.IsShow == '1' ? 'default-btn' : 'search-btn'"
            size="small"
            type="primary"
            @click="editAdvertIsShow(item)"
          >
            <span v-if="item.IsShow == '1'">{{ $t.meta.hide }}</span>
            <span v-else>{{ $t.meta.display }}</span></van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item)"
            >{{ $t.meta.editButton }}</van-button
          >
        </div>
      </div>
    </van-list>

    <option-list
      event="showAdvertListType"
      :options="typeValueOptions"
      @onSelect="onSelectType"
    ></option-list>

    <option-list
      event="showAdvertListIsShow"
      :options="isShowOptions"
      @onSelect="onSelectIsShow"
    ></option-list>

    <option-list
      event="showAdvertListModule"
      :options="moduleOptions"
      @onSelect="onSelectModule"
    ></option-list>

    <van-action-sheet
      :title="$t.meta.searchType"
      :closeable="false"
      v-model="sheetShow"
      :actions="sheetActions"
      @select="sheetSelect"
    />

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.marketRisk.newAdvert
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { List, Row, Col, Button, Form, Field, ActionSheet } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button).use(Form).use(Field).use(ActionSheet);

export default {
  name: "advertList",
  components: {
    OptionList,
  },
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //操作菜单
      sheetShow: false,
      sheetActions: [],
      //filter
      searchType: 1,
      typeValue: "",
      typeValueStr: "",
      typeValueOptions: [],
      isShow: "",
      isShowStr: "",
      isShowOptions: [],
      module: "",
      moduleStr: "",
      moduleOptions: [],
    };
  },
  created() {},
  methods: {
    editAdvertIsShow(item) {
      this.$commonMethod.showLoading();
      var param = {
        AdvertId: item.AdvertId,
        IsShow: item.IsShow == "1" ? 0 : 1,
      };
      this.$api.marketRisk
        .editAdvertIsShow(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    sheetSelect(e) {
      this.searchType = e.className;
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.marketRisk.advertType, className: "1" },
        { name: this.$t.marketRisk.showType, className: "2" },
        { name: this.$t.marketRisk.moduleType, className: "3" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    onSelectType(item) {
      this.typeValue = item.value;
      this.typeValueStr = item.text;
    },
    onSelectIsShow(item) {
      this.isShow = item.value;
      this.isShowStr = item.text;
    },
    onSelectModule(item) {
      this.module = item.value;
      this.moduleStr = item.text;
    },
    onShowEmit(emit) {
      this.typeValueOptions = [
        {
          text: this.$t.marketRisk.all,
          value: "",
        },
        {
          text: this.$t.marketRisk.graphic,
          value: "1",
        },
        {
          text: this.$t.marketRisk.externalLinks,
          value: "2",
        },
      ];
      this.isShowOptions = [
        {
          text: this.$t.marketRisk.all,
          value: "",
        },
        {
          text: this.$t.marketRisk.notDisplay,
          value: "0",
        },
        {
          text: this.$t.marketRisk.display,
          value: "1",
        },
      ];
      this.moduleOptions = [
        {
          text: this.$t.marketRisk.all,
          value: "",
        },
        {
          text: this.$t.marketRisk.pcStation,
          value: "1",
        },
        {
          text: this.$t.marketRisk.wxStation,
          value: "2",
        },
      ];
      this.$bus.$emit(emit, true);
    },
    gotoDetail(item) {
      var data = item;
      localStorage.setItem("advertDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "advertDetail",
        name: "advertDetail",
        query: [
          {
            name: "IsEdit",
            value: data ? true : false,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        AdvertType: this.searchType == 1 ? this.typeValue : "",
        IsShow: this.searchType == 2 ? this.isShow : "",
        ModuleId: this.searchType == 3 ? this.module : "",
        CompanyId: this.CompanyId,
      };
      this.$api.marketRisk
        .getAdvertList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.advertList {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-cell {
          padding: 10px 0px 10px 15px;
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
